<div class="sdp-group-edit-container">
	<div class="sdp-saml-alias-container">
		<div class="group-input">
			<form
				[formGroup]="form"
				class="sdp-saml-wizard-form"
				novalidate
			>
				<div class="sdp-form-control">
					<div class="sdp-form-control-input-container">
						<mat-form-field>
							<mat-select
								placeholder="{{ 'saml-alias.wizard.provider.message' | translate }}"
								formControlName="providerId"
								class="sdp-application-select-type-select"
								(selectionChange)="resetDuplicateGroupError()"
							>
								<mat-option
									*ngFor="let provider of providerData"
									[value]="provider.id"
								>{{ provider.name }} </mat-option>
							</mat-select>
							<mat-error *ngIf="form.controls['providerId'].hasError('required')">{{ "error.message.provider-id.required" | translate }}</mat-error>
						</mat-form-field>
					</div>
				</div>
				<div class="sdp-form-control sdp-saml-alias-wizard-edit-id-container">
					<mat-form-field class="sdp-form-control-input-container">
						<input
							matInput
							placeholder="{{ 'saml-alias.form.label.saml-group' | translate }}"
							type="text"
							formControlName="samlGroup"
						>
						<mat-error *ngIf="form.controls['samlGroup'].hasError('required')">{{ "error.message.saml-group.required" | translate }}</mat-error>
						<mat-error *ngIf="form.controls['samlGroup'].hasError('pattern')">{{ "error.message.saml-group.pattern" | translate }}</mat-error>
						<mat-error *ngIf="form.controls['samlGroup'].hasError('maxlength')">{{ "error.message.saml-group.max-length" | translate }}</mat-error>
						<mat-error *ngIf="form.controls['samlGroup'].hasError('duplicate')">
							{{ getGroupDupeErrorMessage() }}
						</mat-error>
					</mat-form-field>
				</div>
				<div class="sdp-form-control">
					<mat-form-field class="sdp-form-control-input-container">
						<input
							matInput
							[placeholder]="placeholder"
							type="text"
							formControlName="label"
						>
						<mat-error *ngIf="form.controls['label'].hasError('pattern')">{{ "error.message.saml-group.pattern" | translate }}</mat-error>
						<mat-error *ngIf="form.controls['label'].hasError('maxlength')">{{ "error.message.saml-group.max-length" | translate }}</mat-error>
						<mat-error *ngIf="form.controls['label'].hasError('duplicate')">{{ getDisplayDupeErrorMessage() }}
						</mat-error>
					</mat-form-field>
				</div>
			</form>
		</div>
	</div>
</div>